import { createDCHook, collapseDataFromCall } from '../client';
import { getDecarbonizationPotentials } from '../services/DecarbonizationService';

export const useDecarbonizationGetDecarbonizationPotentials = createDCHook(
  'getDecarbonizationPotentials',
  collapseDataFromCall(getDecarbonizationPotentials),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);
